import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=08bbe53e&scoped=true"
import script from "./Editor.vue?vue&type=script&lang=ts"
export * from "./Editor.vue?vue&type=script&lang=ts"
import style0 from "./Editor.vue?vue&type=style&index=0&id=08bbe53e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bbe53e",
  null
  
)

export default component.exports